export default __webpack_public_path__ + "static/char-s-56-zh-Hant-1df5885bc49cb5779969a60fef7b3d00.png";